import { useMutation } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

interface SetRoomTypeAvailabilityParams {
  propertyId: string;
  roomTypeId: string;
  ranges: Array<{ start_date: string; end_date: string; delta: number }>;
}

export function useSetRoomTypeAvailability() {
  return useMutation({
    mutationFn: ({ propertyId, roomTypeId, ranges }: SetRoomTypeAvailabilityParams) =>
      ReservationService.patchAvailability({ op: 'flatten', ranges }, propertyId, roomTypeId),
  });
}
